// DeveloperSection.jsx
import React from 'react';

export const DeveloperSection = () => {
  return (
    <section className="py-32 bg-slate-950">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        <div>
          <h2 className="text-5xl font-bold mb-6 just-me">Built For Developers</h2>

          <p className="text-slate-400 mb-6">
            Ashita Console exposes APIs and modular architecture for developers to build advanced
            CMS applications.
          </p>

          <ul className="space-y-3 text-slate-300">
            <li>REST APIs</li>
            <li>Custom feature deployment</li>
            <li>Dedicated infrastructure</li>
            <li>Developer SDK</li>
          </ul>
        </div>

        <pre className="p-6 rounded-xl bg-black border border-slate-800 text-sm text-green-400 overflow-auto">
          {`const site = await ashita.createSite({
name:"startup-site",
template:"corporate"
})

await ashita.enableFeature("analytics")`}
        </pre>
      </div>
    </section>
  );
};
